export default {
    // nome app
    "SalesPaddy":"SalesPaddy",
    "Submit": "Submit",
    "Note": "Note",
    "NoFeedbackMsg": "There are currently no evaluations to be made.",
    "FillInstruction": {
        "p_1": "Please take a few minutes to evaluate the teachers of the subjects you attended this week. Your feedback is essential to help us improve the quality of our teaching.",
        "p_2": "You can add an optional comment to each rating."
    },
    "Err_Unfilled": "Set a score on each feedback",
    "ThankYouMessage": {
        "p_1": "Thank you for taking the time to share your feedback.",
        "p_survey": "Your input is valuable in helping us improve the learning experience for everyone.",
    },
    "SegnalazioneInstruction": {
        "p_1": "You can use this form to anonymously report a teacher or a situation you have experienced.",
        "p_2": "Your input helps us identify issues and take prompt action.",
        "p_3": "We guarantee that your identity will remain completely anonymous.",
    }
}





